import type { ReceiptTemplate } from '../schema';

export const sephoraTemplate: ReceiptTemplate = {
  id: 'sephora',
  name: 'Sephora Receipt',
  brand: 'SEPHORA',
  description: 'Beauty retail store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'seph-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/sephora.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #0127',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'seph-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'TRANS: 847291  REG: 02\n01/04/26 14:23  CAST: JAMES',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'seph-member',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'BEAUTY INSIDER: ROUGE\nMIKE WAZOWSKI',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'seph-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'seph-item-1', name: 'FENTY FOUNDATION', quantity: '1', price: '42.00'},
          { id: 'seph-item-2', name: 'NARS BLUSH', quantity: '1', price: '30.00'},
          { id: 'seph-item-3', name: 'RARE BEAUTY LIP', quantity: '1', price: '20.00'},
          { id: 'seph-item-4', name: 'OLAPLEX NO.3', quantity: '1', price: '30.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'seph-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        labelAlignment: 'left',
        lines: [
          { id: 'seph-subtotal', label: 'SUBTOTAL', value: '122.00', isBold: false, isLarge: false },
          { id: 'seph-discount', label: 'ROUGE 20%', value: '-24.40', isBold: false, isLarge: false },
          { id: 'seph-tax', label: 'TAX', value: '8.66', isBold: false, isLarge: false },
          { id: 'seph-total', label: 'TOTAL', value: '106.26', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'seph-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'seph-card', label: 'VISA', value: '************4144' },
          { id: 'seph-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'seph-points',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'POINTS EARNED: 106\nTOTAL POINTS: 2,847\nYOU SAVED: $24.40',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'seph-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '0127847291',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'seph-return',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'RETURNS WITHIN 60 DAYS\nWITH RECEIPT\nSEPHORA.COM',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

